import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';

export class GetProviderBrandsUseCase {
  constructor (private repo: ServiceProviderRepository) {}

  async execute (): Promise<any[]> {
    return this.repo.getProviderBrands();
  }
}
